import { cn } from "@/lib/utils";

export const NO_PERSONAL_DATA_HINT =
  "Trage hier keine personenbezogenen Daten ein (wie deine Email-Adresse oder Anschrift)";

export const PRIVATE_ANSWERS_DISCLAIMER =
  "Deine Eingaben sind nur für dich sichtbar";

interface InputPrivacyNoticeProps {
  className?: string;
  id?: string;
}

/**
 * Helper next to a prose answer field — tells the learner not to enter
 * personal data. Prefer `sr-only` when the same copy is shown as the field
 * placeholder so the warning stays available to assistive tech.
 */
const InputPrivacyNotice = ({ className, id }: InputPrivacyNoticeProps) => (
  <p id={id} className={cn("text-sm text-muted-foreground", className)}>
    {NO_PERSONAL_DATA_HINT}
  </p>
);

export default InputPrivacyNotice;
